export type ConversationPosition =
  | { atBottom: true }
  | { atBottom: false; messageId: string; fraction: number }

/** Message-relative progress survives the different widths of the two views. */
export function captureConversationPosition(
  viewport: HTMLElement | null,
  stickToBottom = true,
): ConversationPosition {
  if (
    !viewport ||
    (stickToBottom &&
      viewport.scrollHeight - viewport.scrollTop - viewport.clientHeight <= 24)
  )
    return { atBottom: true }
  const top = viewport.getBoundingClientRect().top
  const message = Array.from(
    viewport.querySelectorAll<HTMLElement>('[data-conversation-message]'),
  ).find(element => element.getBoundingClientRect().bottom > top)
  if (!message) return { atBottom: true }
  const rect = message.getBoundingClientRect()
  return {
    atBottom: false,
    messageId: message.dataset.conversationMessage!,
    fraction: Math.max(
      0,
      Math.min(1, (top - rect.top) / Math.max(1, rect.height)),
    ),
  }
}

export function restoreConversationPosition(
  viewport: HTMLElement,
  position: ConversationPosition,
): boolean {
  if (position.atBottom === true) {
    viewport.scrollTop = viewport.scrollHeight
    return true
  }
  const message = Array.from(
    viewport.querySelectorAll<HTMLElement>('[data-conversation-message]'),
  ).find(element => element.dataset.conversationMessage === position.messageId)
  if (!message) return false
  const rect = message.getBoundingClientRect()
  viewport.scrollTop +=
    rect.top -
    viewport.getBoundingClientRect().top +
    rect.height * position.fraction
  return true
}
